import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FiFilter, FiPlus, FiCheck, FiX, FiArrowLeft, FiRefreshCw } from 'react-icons/fi'

// Common button styles
const baseButtonStyle = {
    borderRadius: '10px',
    padding: '10px 20px',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    border: 'none',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
};

// Hover wrapper component - exported for reuse
export function HoverButton({ children, style, hoverStyle, ...props }) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Button
            {...props}
            style={{
                ...style,
                ...(isHovered ? hoverStyle : {})
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {children}
        </Button>
    );
}

// -----| Button Filter |-----
export function ButtonFilter({ onClick }) {
    return (
        <HoverButton
            onClick={onClick}
            style={{
                ...baseButtonStyle,
                background: '#f8f9fa',
                color: '#495057',
                border: '2px solid #e9ecef'
            }}
            hoverStyle={{
                background: '#e9ecef',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}
        >
            <FiFilter size={18} />
            Filtrar
        </HoverButton>
    )
}

// -----| Button New |-----
export function ButtonNew({ onClick }) {
    return (
        <HoverButton
            onClick={onClick}
            style={{
                ...baseButtonStyle,
                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                color: '#fff'
            }}
            hoverStyle={{
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 20px rgba(17, 153, 142, 0.4)'
            }}
        >
            <FiPlus size={18} />
            Nuevo
        </HoverButton>
    )
}

// -----| Button Save |-----
export function ButtonSave({ onClick, className = '' }) {
    return (
        <HoverButton
            onClick={onClick}
            className={className}
            style={{
                ...baseButtonStyle,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#fff',
                minWidth: '140px'
            }}
            hoverStyle={{
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)'
            }}
        >
            <FiCheck size={18} />
            Guardar
        </HoverButton>
    )
}

// -----| Button Delete |-----
export function ButtonDelete({ onClick, className = '' }) {
    return (
        <HoverButton
            onClick={onClick}
            className={className}
            style={{
                ...baseButtonStyle,
                background: 'linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)',
                color: '#fff',
                minWidth: '140px'
            }}
            hoverStyle={{
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 20px rgba(255, 65, 108, 0.4)'
            }}
        >
            <FiX size={18} />
            Eliminar
        </HoverButton>
    )
}

// -----| Button Cancel |-----
export function ButtonCancel({ to, onClick, disabled, className = '' }) {
    const [isHovered, setIsHovered] = useState(false);

    const style = {
        ...baseButtonStyle,
        background: isHovered && !disabled ? '#e9ecef' : '#f8f9fa',
        color: '#495057',
        border: '2px solid #e9ecef',
        minWidth: '140px',
        opacity: disabled ? 0.6 : 1,
        transform: isHovered && !disabled ? 'translateY(-2px)' : 'none',
        boxShadow: isHovered && !disabled ? '0 4px 12px rgba(0,0,0,0.15)' : '0 2px 8px rgba(0,0,0,0.1)'
    };

    const hoverProps = {
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false)
    };

    if (to) {
        return (
            <Button
                as={Link}
                to={to}
                className={className}
                disabled={disabled}
                style={style}
                {...hoverProps}
            >
                <FiArrowLeft size={18} />
                Cancelar
            </Button>
        )
    }

    return (
        <Button
            onClick={onClick}
            className={className}
            disabled={disabled}
            style={style}
            {...hoverProps}
        >
            <FiArrowLeft size={18} />
            Cancelar
        </Button>
    )
}

// -----| Button Refresh |-----
export function ButtonRefresh({ onClick, className = '' }) {
    return (
        <HoverButton
            onClick={onClick}
            className={className}
            style={{
                ...baseButtonStyle,
                background: '#f8f9fa',
                color: '#495057',
                border: '2px solid #e9ecef'
            }}
            hoverStyle={{
                background: '#e9ecef',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}
        >
            <FiRefreshCw size={18} />
            Refrescar
        </HoverButton>
    )
}

// -----| Button Accept |-----
export function ButtonAccept({ onClick, className = '' }) {
    return (
        <HoverButton
            onClick={onClick}
            className={className}
            style={{
                ...baseButtonStyle,
                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                color: '#fff',
                minWidth: '140px'
            }}
            hoverStyle={{
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 20px rgba(17, 153, 142, 0.4)'
            }}
        >
            <FiCheck size={18} />
            Aceptar
        </HoverButton>
    )
}

// -----| Button Close |-----
export function ButtonClose({ onClick, className = '' }) {
    return (
        <HoverButton
            onClick={onClick}
            className={className}
            style={{
                ...baseButtonStyle,
                background: '#f8f9fa',
                color: '#495057',
                border: '2px solid #e9ecef',
                minWidth: '140px'
            }}
            hoverStyle={{
                background: '#e9ecef',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}
        >
            <FiX size={18} />
            Cerrar
        </HoverButton>
    )
}
